import {useLocation, useNavigate} from 'react-router';
import type {FC} from 'react';
import type {MenuItemProps, TMenuItem} from '../types';
import {getCurrentFocusKey, setFocus, useFocusable} from '@noriginmedia/norigin-spatial-navigation';
import {Icon, Label, MenuLink} from '../types/MenuItem.styled.ts';
import Streaming from '../../../assets/menus/streaming.svg';
import Tv from '../../../assets/menus/tv.svg';
import Replay from '../../../assets/menus/replay.svg';
import Message from '../../../assets/menus/message.svg';
import VideoCall from '../../../assets/menus/call.svg';
import Bus from '../../../assets/menus/bus.svg';
import useStreamingStore from '../../../store/useStreamingStore.ts';

const iconMap: Record<TMenuItem['name'], string> = {
    streaming: Streaming,
    iptv: Tv,
    replay: Replay,
    message: Message,
    videoCall: VideoCall,
    busArrived: Bus,
};

const MenuItem: FC<MenuItemProps> = ({item, isActive}) => {
    const icon = iconMap[item.name];
    const location = useLocation();
    const navigate = useNavigate();
    const deviceID = localStorage.getItem('deviceID') ?? 'test';
    const {streamingPollingData} = useStreamingStore();

    const {ref, focused} = useFocusable({
        focusKey: item.name,
        onEnterPress: () => {
            navigate(`/${item.name}?deviceID=${deviceID}`);
        },
        onFocus: () => {
            ref.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            });
        },
        onArrowPress: (direction) => {
            if (getCurrentFocusKey() === 'iptv' && direction === 'left') {
                return false;
            }
            if (getCurrentFocusKey() === 'iptv' && direction === 'up') {
                setFocus('weather');
                return false;
            }
            if (getCurrentFocusKey() === 'replay' && direction === 'down') {
                if (location.pathname === '/streaming' || location.pathname === '/iptv') {
                    setFocus('streaming-page-full-icon');
                    return false;
                }
                return false;
            }
            return direction !== 'left';
        },
    });

    return (
        <MenuLink ref={ref} to={`/${item.name}?deviceID=${deviceID}`} $active={isActive} $focused={focused}>
            <Icon src={icon} alt={item.name_kor} $active={isActive} $focused={focused} />
            <Label $focused={focused}>{item.name_kor}</Label>
        </MenuLink>
    );
};

export default MenuItem;
